import {message, Modal} from 'antd';
import {
  AccountFieldsFragment,
  useConnectMasterAccountMutation,
} from 'api/generated';
import {Formik} from 'formik';
import {Form, FormItem, Select} from 'formik-antd';
import { useMasterAccounts } from 'hooks/useMasterAccounts';
import React from 'react';
import * as yup from 'yup';

type Props = {
  account?: AccountFieldsFragment | null;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const validationSchema = yup.object().shape({
  promoCode: yup.string()
});

export const MasterAccountsListModal: React.FC<Props> = ({account, isOpen, setIsOpen}) => {
  const [connectMasterAccount] = useConnectMasterAccountMutation();
  const {selectOptions} = useMasterAccounts();
  if (!account) return null;

  const initialValues = {
    promoCode: account?.promoCode || ''
  };

  const handleSubmit = async ({promoCode}: typeof initialValues) => {
    await connectMasterAccount({
      variables: {accountId: account.id, promoCode, externalId: '', externalHash: ''}
    });
    message.success('Master account connected.');
    setIsOpen(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Master account list"
            okText="Connect"
            okType="primary"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            width={640}
            afterClose={resetForm}
            onCancel={() => {
              setIsOpen(false);
            }}>
            <Form layout="vertical">
              <p>This will connect the account to the master account.</p>
              <FormItem name="promoCode" label="Master account">
                <Select
                  showSearch
                  name="promoCode"
                  allowClear
                  optionFilterProp="label"
                  placeholder="Select master account"
                  style={{width: '100%'}}
                  options={selectOptions}></Select>
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
